module.exports = __webpack_public_path__ + "img/trust-down-bg.bffe7917.png";